import React from 'react';

// eslint-disable-next-line react/prop-types
const ReceiptCta = ({ appointments, appLink }) => (
  <div>
    {appointments.length ? (
      <div className="u-mt-8 u-mb-6">
        <a
          className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold"
          href={appLink}
          target="_blank"
        >
          Change Payment
        </a><span className="u-text-large u-fw-bold">,</span>&nbsp;
        <a className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold" href={appLink} target="_blank">
          Modify Tip
        </a><br />
        <span className="u-text-large u-fw-bold"> or </span>
        <a
          className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold"
          href={appLink}
          target="_blank"
        >
          Book Next Appointment
        </a>
        <span className="u-text-large u-fw-bold">
          <br />using our free app.
        </span>
      </div>
    ) : (
      <div className="u-mt-8 u-mb-6">
        <a
          className="u-text-large u-td-none u-dotted-border u-co-black u-fw-bold"
          href={appLink}
          target="_blank"
        >
          Book your next haircut
        </a>
        <span className="u-text-large u-fw-bold">
          <br />using our free app.
        </span>
      </div>
    )}
    <div className="u-flex">
      <a className="c-store-button u-mr-4" href={appLink} target="_blank">
        <img src="https://squire-emails.s3-us-west-1.amazonaws.com/images/google-play.png" alt="" />
      </a>
      <a className="c-store-button" href={appLink} target="_blank">
        <img src="https://squire-emails.s3-us-west-1.amazonaws.com/images/app-store.png" alt="" />
      </a>
    </div>
  </div>
);

export default ReceiptCta;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/ReceiptCta.jsx